/**
 * recommendationEngine.js — Re Leve IA (Etapa 4)
 * Recomendação determinística de kit por segmento e intenção.
 * Não usa valores financeiros brutos. Usa segmento comercial simulado.
 */

import kitsData from '../data/kits.json';

function getKit(id) {
  return kitsData.find(k => k.id === id) || null;
}

function buildRec(kit, reason, cta, caution) {
  if (!kit) return null;
  return {
    kitId: kit.id,
    kitName: kit.nome,
    reason,
    cta: cta || kit.ctaSugerido,
    caution: caution || '',
    items: kit.composicao || [],
    source: 'Regra determinística por segmento e intenção',
  };
}

export function getRecommendedKitForCustomer({ customer, intent, memoryContext }) {
  const seg = (
    customer?.segmentoComercial ||
    customer?.segmento ||
    customer?.segment ||
    ''
  ).toLowerCase();

  const isColetivo = seg.includes('coletivo');
  const isFiel = seg.includes('fiel');
  const isAltoValor = seg.includes('alto valor');
  const isRecorrente = seg.includes('recorrente');
  const isNovo = seg.includes('novo');
  const isBaixoTicket = seg.includes('baixo ticket');
  const isInativo = seg.includes('inativo');

  // Por intenção específica
  if (intent === 'montar_semana') {
    if (isColetivo) return buildRec(
      getKit('KIT_008'),
      'Cliente com perfil coletivo — Escritório Saudável é o mais adequado.',
      'Para alimentação de equipe, temos condições especiais. Posso encaminhar para nosso atendimento comercial?',
      'Confirmar se a compra é para equipe antes de prosseguir (G09).'
    );
    if (isFiel || isAltoValor) return buildRec(
      getKit('KIT_006'),
      'Cliente fiel ou alto valor — Semana Completa Re Leve é a escolha natural.',
      'Semana 100% resolvida com a Re Leve! 7 dias completos. Quer montar?',
      ''
    );
    if (isRecorrente) return buildRec(
      getKit('KIT_005'),
      'Cliente recorrente — Semana Útil Resolvida cobre os 5 dias úteis.',
      'Posso montar sua semana: almoço, jantar, snack e bebida para os 5 dias. Quer?',
      ''
    );
    return buildRec(
      getKit('KIT_004'),
      'Cliente novo ou padrão — Semana Econômica é a porta de entrada ideal.',
      'Que tal resolver os almoços da semana de forma prática e econômica?',
      ''
    );
  }

  if (intent === 'kit_dia') {
    if (isFiel || isAltoValor) return buildRec(
      getKit('KIT_003'),
      'Cliente fiel — Kit Dia Performance disponível como upgrade.',
      'Para uma rotina mais intensa, o Kit Dia Performance pode ser ideal!',
      ''
    );
    return buildRec(
      getKit('KIT_001'),
      'Kit Dia Leve: almoço, jantar, snack e bebida para o dia.',
      'Quer resolver o dia completo? Posso montar um Kit Dia Leve para você!',
      ''
    );
  }

  if (intent === 'registrar_calorias') {
    return buildRec(
      getKit('KIT_002'),
      'Kit Dia Controle inclui registro calórico informativo.',
      'Posso montar um kit equilibrado com registro calórico informativo. Tem interesse?',
      'Solicitar consentimento G06 antes de registrar qualquer dado.'
    );
  }

  if (intent === 'compra_coletiva') {
    return buildRec(
      getKit('KIT_008'),
      'Compra coletiva — Escritório Saudável com encaminhamento humano.',
      'Para alimentação de equipe, temos condições especiais. Posso encaminhar para nosso atendimento comercial?',
      'Confirmar contexto antes de tratar como B2B (G09).'
    );
  }

  if (intent === 'promocoes') {
    if (isFiel || isAltoValor) return buildRec(
      getKit('KIT_006'),
      'Cliente fiel — Semana Completa como oferta premium.',
      'Semana 100% resolvida com a Re Leve! 7 dias completos. Quer montar?',
      ''
    );
    return buildRec(
      getKit('KIT_005'),
      'Semana Útil Resolvida como destaque de promoção.',
      'Posso montar sua semana: almoço, jantar, snack e bebida para os 5 dias. Quer?',
      ''
    );
  }

  // Fallback por segmento
  if (isColetivo) return buildRec(getKit('KIT_008'), 'Segmento coletivo — Escritório Saudável.', '', 'Confirmar contexto (G09).');
  if (isFiel) return buildRec(getKit('KIT_006'), 'Segmento fiel — Semana Completa.', '', '');
  if (isAltoValor) return buildRec(getKit('KIT_006'), 'Segmento alto valor — Semana Completa.', '', '');
  if (isRecorrente) return buildRec(getKit('KIT_005'), 'Segmento recorrente — Semana Útil Resolvida.', '', '');
  if (isInativo) return buildRec(getKit('KIT_004'), 'Segmento inativo — Semana Econômica para reativação.', '', '');
  if (isBaixoTicket) return buildRec(getKit('KIT_001'), 'Baixo ticket — Kit Dia Leve como porta de entrada.', '', '');
  if (isNovo) return buildRec(getKit('KIT_004'), 'Cliente novo — Semana Econômica para primeira experiência.', '', '');

  return buildRec(getKit('KIT_001'), 'Kit padrão para demonstração.', '', '');
}

export function recommendKit(customerProfile) {
  return getRecommendedKitForCustomer({
    customer: customerProfile,
    intent: 'fallback',
    memoryContext: null,
  });
}
